// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3RMTa","title":"Info_title__Eu1CG","links":"Info_links__Wv-GB","link":"Info_link__3PL6S","logo":"Info_logo__12rm6"};